import type { Recipe } from "@/features/recipes/types";
import { apiClient } from "@/lib/apiClient";

export type CreateRecipePayload = {
  name: string;
  description?: string;
  /** Required by the API: a recipe always produces one product. */
  productId: string;
  ingredients: Array<{
    provisionId: string;
    quantity: number;
  }>;
};

/**
 * The product a recipe produces is fixed at creation, so an update only
 * carries the name, the description and the ingredient list.
 */
export type UpdateRecipePayload = {
  name?: string;
  description?: string;
  ingredients?: Array<{ provisionId: string; quantity: number }>;
};

export type DeletedRecipe = {
  id: string;
  name: string;
  productId: string;
  isDeleted: boolean;
  deletedAt: string | null;
  deletedSupplyingCount: number;
};

export const RECIPES_KEY = "recipes";

export const listRecipes = async (): Promise<Recipe[]> => {
  const recipes = await apiClient.get<Recipe[]>(RECIPES_KEY);
  return Array.isArray(recipes) ? recipes : [];
};

export const createRecipe = (payload: CreateRecipePayload): Promise<Recipe> =>
  apiClient.post<Recipe>(RECIPES_KEY, payload);

export const updateRecipe = (id: string, payload: UpdateRecipePayload): Promise<Recipe> =>
  apiClient.put<Recipe>(`recipes/${id}`, payload);

export const deleteRecipe = (id: string): Promise<DeletedRecipe> => apiClient.delete<DeletedRecipe>(`recipes/${id}`);
